const GameBoardData = [

  // Define each territory button with its position, name, and ruler
// Left Continents
{ id: 1, x: 11.8, y: 23.3, territoryName: 'Alaska', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0, lastTroopsCount: 0, territoryHolder: {x: '2.5%', y: '20%', width: '3.5%', height: '65%'}, 
overlayStyle: { position: 'absolute',
 top: `5%`,
 left: `0.8%`,
 width: `6%`,
 height: `60%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-40%`,
  left: `-1.5%`
}, territoryWidth:  '8.25%', territoryHeight: '12.25vh'},
{ id: 2, x: 17.75, y: 20.7, territoryName: 'North West Territory', territoryImage: './Assets/Images/GameBoard/WorldMap/NorthWestTerritory/NorthWestTerritory.png', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3.2%', y: '40%', width: '3.5%', height: '80%'},
overlayStyle: { position: 'absolute',
 top: `48%`,
 left: `0.6%`,
 width: `13%`,
 height: `40%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-40%`,
  left: `-0.75%`
}, territoryWidth:  '13.6%', territoryHeight: '9vh' },

{ id: 3, x: 19.45, y: 29.45, territoryName: 'Alberta', territoryImage: './Assets/Images/GameBoard/WorldMap/Alberta/Alberta.png', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '16%', width: '3.5%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `1%`,
 left: `0%`,
 width: `7%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-70%`,
  left: `-2%`
}, territoryWidth:  '7.1%', territoryHeight: '8.5vh' },
{ id: 4, x: 26.6, y: 29.4, territoryName: 'Ontario', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '1%', y: '20%', width: '3.5%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `1%`,
 left: `0%`,
 width: `4%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-65%`,
  left: `-3%`
}, territoryWidth:  '5%' ,territoryHeight: '8.7vh' },
{ id: 5, x: 31.9, y: 29.3, territoryName: 'Quebec', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '1%', y: '20%', width: '3.5%', height: '75%'}, 
overlayStyle: { position: 'absolute',
 top: `1%`,
 left: `0.5%`,
 width: `4%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-45%`,
  left: `-3%`
}, territoryWidth:  '5.7%' ,territoryHeight: '11vh' },
{ id: 6, x: 22.1, y: 37.85, territoryName: 'Western UnitedStates', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '1.5%', y: '20%', width: '3.5%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `1%`,
 left: `0.2%`,
 width: `5%`,
 height: `70%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-65%`,
  left: `-2.5%`
}, territoryWidth:  '5.2%' ,territoryHeight: '8.7vh' },
{ id: 7, x: 25.1, y: 36.3, territoryName: 'Eastern UnitedStates', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3.25%', y: '16%', width: '4.5%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `17%`,
 left: `1.7%`,
 width: `7%`,
 height: `55%`,
 cursor: 'pointer',
 transform: `rotate(${-40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-35%`,
  left: `-0.5%`
}, territoryWidth:  '9.2%' ,territoryHeight: '13vh' },
{ id: 8, x: 23.45, y: 44.9, territoryName: 'Central America', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '15%', width: '4.5%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `32%`,
 left: `0.5%`,
 width: `11%`,
 height: `30%`,
 cursor: 'pointer',
 transform: `rotate(${30}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-32%`,
  left: `-0.65%`
}, territoryWidth:  '13.5%' ,territoryHeight: '14vh' },
{ id: 9, x: 30.75, y: 58.3, territoryName: 'Peru', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '30%', width: '4.5%', height: '80%'},
 overlayStyle: { position: 'absolute',
 top: `30%`,
 left: `-1%`,
 width: `8%`,
 height: `40%`,
 cursor: 'pointer',
 transform: `rotate(${30}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-28%`,
  left: `-0.65%`
}, territoryWidth:  '7.5%',territoryHeight: '12vh' },
{ id: 10, x: 32.55, y: 55.7, territoryName: 'Brazil', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '4%', y: '18%', width: '5%', height: '65%'}, 
overlayStyle: { position: 'absolute',
 top: `13%`,
 left: `1%`,
 width: `9.5%`,
 height: `40%`,
 cursor: 'pointer',
 transform: `rotate(${30}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-18%`,
  left: `0.5%`
}, territoryWidth:  '11.1%',territoryHeight: '18vh' },
{ id: 11, x: 32.4, y: 67.55, territoryName: 'Argentina', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2.5%', y: '18%', width: '5%', height: '65%'}, 
overlayStyle: { position: 'absolute',
 top: `8%`,
 left: `0.5%`,
 width: `4%`,
 height: `80%`,
 cursor: 'pointer',
 transform: `rotate(${20}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-20%`,
  left: `-1%`
}, territoryWidth:  '6.5%',territoryHeight: '17.7vh' },
// Connecting Node From Left Continent - Top Territory
{ id: 12, x: 33.4, y: 12.5, territoryName: 'Greenland', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3.8%', y: '16%', width: '5%', height: '65%'}, 
overlayStyle: { position: 'absolute',
 top: `10%`,
 left: `3%`,
 width: `8%`,
 height: `70%`,
 cursor: 'pointer',
 transform: `rotate(${-40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-15%`,
  left: `0.15%`
}, territoryWidth:  '12.7%' ,territoryHeight: '18.8vh' },
//#region Middle East & Europe
{ id: 13, x: 45.5, y: 20.8, territoryName: 'Iceland', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2.5%', y: '5%', width: '3%', height: '85%'}, 
overlayStyle: { position: 'absolute',
 top: `20%`,
 left: `0.5%`,
 width: `4%`,
 height: `60%`,
 cursor: 'pointer',
 transform: `rotate(${-30}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-65%`,
  left: `-1.5%`
}, territoryWidth:  '4.8%' ,territoryHeight: '6.5vh' },
// Bottom Connecting Node
{ id: 14, x: 44.8, y: 28.2, territoryName: 'Great Britain', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '1.2%', y: '20%', width: '3%', height: '85%' }, 
overlayStyle: { position: 'absolute',
 top: `5%`,
 left: `0.5%`,
 width: `2.8%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-75%`,
  left: `-2.75%`
}, territoryWidth:  '3.6%' ,territoryHeight: '5.5vh' },
//Right Connecting Node
{ id: 15, x: 49.7, y: 20.6  , territoryName: 'Scandinavia', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '1.5%', y: '20%', width: '3.8%', height: '85%'}, 
overlayStyle: { position: 'absolute',
 top: `-5%`,
 left: `1.8%`,
 width: `2.8%`,
 height: `100%`,
 cursor: 'pointer',
 transform: `rotate(${40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-35%`,
  left: `-2.25%`
}, territoryWidth:  '5.45%' ,territoryHeight: '11vh' },
// Normal LandLocked Regions
{ id: 16, x: 49.5, y: 29, territoryName: 'Northern Europe', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '30%', width: '2.5%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `25%`,
 left: `0.5%`,
 width: `4%`,
 height: `50%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-80%`,
  left: `-2.25%`
}, territoryWidth:  '5.1%' ,territoryHeight: '6vh' },
{ id: 17, x: 46.2, y: 32.2, territoryName: 'Western Europe', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '20%', width: '3%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `10%`,
 left: `0.7%`,
 width: `2.3%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${50}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-55%`,
  left: `-2.1%`
}, territoryWidth:  '4.3%' ,territoryHeight: '8.7vh' },
{ id: 18, x: 50, y: 33.1, territoryName: 'Southern Europe', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '20%', width: '3.5%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `20%`,
 left: `0.4%`,
 width: `4.2%`,
 height: `50%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-60%`,
  left: `-2%`
}, territoryWidth:  '5.3%',territoryHeight: '7.9vh'  },
{ id: 19, x: 53.55, y: 21.1, territoryName: 'Ukraine', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '4.5%', height: '60%'}, 
overlayStyle: { position: 'absolute',
 top: `2%`,
 left: `2.5%`,
 width: `4%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-15.5%`,
  left: `-0.65%`
}, territoryWidth:  '8.9%' ,territoryHeight: '16.7vh' },
{ id: 20, x: 61.15, y: 18.5, territoryName: 'Ural', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '1.5%', y: '20%', width: '4.5%', height: '60%'},
overlayStyle: { position: 'absolute',
 top: `7%`,
 left: `0.8%`,
 width: `3%`,
 height: `80%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-15%`,
  left: `-2.1%`
}, territoryWidth:  '4.4%' ,territoryHeight: '17.2vh' },
{ id: 21, x: 58.7, y: 31.3, territoryName: 'Afganistan', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '12%', width: '4%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `2%`,
 left: `1%`,
 width: `3%`,
 height: `78%`,
 cursor: 'pointer',
transform: `rotate(${-40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-50%`,
  left: `-0.8%`
}, territoryWidth:  '5.65%' ,territoryHeight: '9.8vh' },
{ id: 22, x: 54.1, y: 37.7, territoryName: 'Middle East', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '4%', height: '70%'}, 
overlayStyle: { position: 'absolute',
 top: `0%`,
 left: `2.5%`,
 width: `3.5%`,
 height: `100%`,
 cursor: 'pointer',
 transform: `rotate(${-40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-30%`,
  left: `-0.8%`
}, territoryWidth:  '7.9%' ,territoryHeight: '12.5vh' },
{ id: 23, x: 61.1, y: 38.9, territoryName: 'India', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2.75%', y: '20%', width: '5%', height: '60%'}, 
overlayStyle: { position: 'absolute',
 top: `0%`,
 left: `2%`,
 width: `3%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${-30}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-13%`,
  left: `-0.7%`
}, territoryWidth:  '6.8%' ,territoryHeight: '17.5vh' },
{ id: 24, x: 62.2, y: 34.7, territoryName: 'China', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '4%', height: '60%'}, 
overlayStyle: { position: 'absolute',
 top: `25%`,
 left: `1.5%`,
 width: `10%`,
 height: `40%`,
 cursor: 'pointer',
 transform: `rotate(${25}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-25%`,
  left: `-0.75%`
}, territoryWidth:  '12.4%' ,territoryHeight: '14vh' },
{ id: 25, x: 64.2, y: 19.5, territoryName: 'Siberia', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '20%', width: '4%', height: '60%'}, 
overlayStyle: { position: 'absolute',
 top: `2%`,
 left: `1.2%`,
 width: `3.5%`,
 height: `80%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-18%`,
  left: `-1.75%`
}, territoryWidth:  '5.6%' ,territoryHeight: '16.2vh' },
{ id: 26, x: 68.7, y: 24.7, territoryName: 'Tajakistan', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '20%', width: '3%', height: '75%'}, 
overlayStyle: { position: 'absolute',
 top: `10%`,
 left: `0.7%`,
 width: `3.5%`,
 height: `70%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-63%`,
  left: `-2.1%`
}, territoryWidth:  '4.5%' ,territoryHeight: '8vh' },
{ id: 27, x: 66.6, y: 30.75, territoryName: 'Syria', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '4%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `30%`,
 left: `1%`,
 width: `8%`,
 height: `40%`,
 cursor: 'pointer',
 transform: `rotate(${20}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-35%`,
  left: `-0.8%`
}, territoryWidth:  '9.8%' ,territoryHeight: '11vh' },
{ id: 28, x: 72.55, y: 29.2, territoryName: 'Mangolia', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '0.5%', y: '15%', width: '3.5%', height: '85%'}, 
overlayStyle: { position: 'absolute',
 top: `28%`,
 left: `0%`,
 width: `5.5%`,
 height: `40%`,
 cursor: 'pointer',
 transform: `rotate(${40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-58%`,
  left: `-3.4%`
}, territoryWidth:  '5.8%' ,territoryHeight: '8.7vh' },
{ id: 29, x: 74.75, y: 26.5, territoryName: 'IRKLITSK', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '1%', y: '20%', width: '2.5%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `15%`,
 left: `1%`,
 width: `2.2%`,
 height: `70%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-70%`,
  left: `-3.2%`
}, territoryWidth:  '6.3%' ,territoryHeight: '7vh' },
{ id: 30, x: 75.85, y: 23.75, territoryName: 'Nigeria', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '30%', width: '2.5%', height: '95%'}, 
overlayStyle: { position: 'absolute',
 top: `25%`,
 left: `0.5%`,
 width: `4.7%`,
 height: `40%`,
 cursor: 'pointer',
 transform: `rotate(${10}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-98%`,
  left: `-2.25%`
}, territoryWidth:  '5.3%',territoryHeight: '5vh'  },
{ id: 31, x: 76.3, y: 19, territoryName: 'YAKLITSK', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '1%', y: '20%', width: '3%', height: '95%'},
overlayStyle: { position: 'absolute',
 top: `-5%`,
 left: `0.75%`,
 width: `3%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${30}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-72%`,
  left: `-3.1%`
}, territoryWidth:  '5.15%' ,territoryHeight: '6.9vh' },
{ id: 32, x: 79.9, y: 20.5, territoryName: 'Kamchatka', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '16%', width: '4.5%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `8%`,
 left: `0.75%`,
 width: `7%`,
 height: `50%`,
 cursor: 'pointer',
 transform: `rotate(${10}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-30%`,
  left: `-1.5%`
}, territoryWidth:  '8.2%' ,territoryHeight: '12.9vh' },
{ id: 33, x: 67.7, y: 45, territoryName: 'Slam', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2.25%', y: '18%', width: '3.5%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `25%`,
 left: `0%`,
 width: `4.5%`,
 height: `40%`,
 cursor: 'pointer',
 transform: `rotate(${40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-48%`,
  left: `-1.7%`
}, territoryWidth:  '4.2%' ,territoryHeight: '9.5vh' }, // Lower Most Territory
//#region Linked Territory - Australisian Continent
{ id: 34, x: 69, y: 55.6, territoryName: 'Indonesia', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0, lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '4.5%', height: '80%'},
overlayStyle: { position: 'absolute',
 top: `15%`,
 left: `1%`,
 width: `6.5%`,
 height: `80%`,
 cursor: 'pointer',
 transform: `rotate(${-30}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-32%`,
  left: `-0.65%`
}, territoryWidth:  '7.9%' ,territoryHeight: '11.5vh' },
{ id: 35, x: 78, y: 55.6, territoryName: 'New Guinea', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '3%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `25%`,
 left: `-0.5%`,
 width: `6.5%`,
 height: `50%`,
 cursor: 'pointer',
 transform: `rotate(${40}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-62%`,
  left: `-1.1%`
}, territoryWidth:  '5.3%' ,territoryHeight: '8vh' }, // Connecting Territory
{ id: 36, x: 77.9, y: 61.8, territoryName: 'Eastern Australia', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '5.5%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `10%`,
 left: `3.2%`,
 width: `3.3%`,
 height: `90%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-18%`,
  left: `-0.25%`
}, territoryWidth:  '6.5%',territoryHeight: '15vh'  }, // Connecting Territory
{ id: 37, x: 74.1, y: 63.4, territoryName: 'Western Australia', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '5%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `30%`,
 left: `0%`,
 width: `7%`,
 height: `60%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-22%`,
  left: `-0.5%`
}, territoryWidth:  '7.1%',territoryHeight: '13.5vh'  }, // Connecting Territory

//#endregion
{ id: 38, x: 75.8, y: 33.1, territoryName: 'Japan', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '16%', width: '4.5%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `40%`,
 left: `-0.5%`,
 width: `8%`,
 height: `30%`,
 cursor: 'pointer',
 transform: `rotate(${-45}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-30%`,
  left: `-0.75%`
}, territoryWidth:  '6.6%' ,territoryHeight: '12.7vh' }, // Russia Linked Territory
//
//#endregion
// Connecting Node From Left Continent Bottom - Africa Continent
//#region African Continent
{ id: 39, x: 44.55, y: 39.7, territoryName: 'North Africa', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '5%', height: '80%'}, 
overlayStyle: { position: 'absolute',
 top: `10%`,
 left: `0%`,
 width: `7.5%`,
 height: `80%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-18%`,
  left: `-0.5%`
}, territoryWidth:  '9.5%' ,territoryHeight: '15.2vh' },
{ id: 40, x: 51.75, y: 41.2, territoryName: 'Egypt', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '2%', y: '20%', width: '2.5%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `0%`,
 left: `0.1%`,
 width: `4%`,
 height: `80%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-95%`,
  left: `-2.2%`
}, territoryWidth:  '4.3%',territoryHeight: '5.7vh'  },
{ id: 41, x: 53.5, y: 45.1, territoryName: 'East Africa', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '5%', height: '70%'}, 
overlayStyle: { position: 'absolute',
 top: `0%`,
 left: `1.3%`,
 width: `3.5%`,
 height: `80%`,
 cursor: 'pointer',
 transform: `rotate(${-30}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-12%`,
  left: `-0.5%`
}, territoryWidth:  '6.5%' ,territoryHeight: '17.1vh' },
{ id: 42, x: 49.6, y: 51.4, territoryName: 'Congo', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3.25%', y: '16%', width: '3.5%', height: '90%'}, 
overlayStyle: { position: 'absolute',
 top: `20%`,
 left: `0.1%`,
 width: `5.5%`,
 height: `60%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-55%`,
  left: `-0.75%`
}, territoryWidth:  '6%' ,territoryHeight: '8.7vh' },
{ id: 43, x: 50.65, y: 56.5, territoryName: 'South Africa', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '3%', y: '20%', width: '5%', height: '80%'},
overlayStyle: { position: 'absolute',
 top: `18%`,
 left: `0.3%`,
 width: `5%`,
 height: `80%`,
 cursor: 'pointer',
 transform: `rotate(${0}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-18%`,
  left: `-0.5%`
}, territoryWidth:  '7.15%' ,territoryHeight: '15vh' },
{ id: 44, x: 57.6, y: 59.2, territoryName: 'Madgascar', territoryImage: '', territoryRuler: '', isSelectedTerritory: false, isTagetTerritory: false, troopsCount: 0 , lastTroopsCount: 0, territoryHolder: {x: '0.5%', y: '20%', width: '3%', height: '90%'},
overlayStyle: { position: 'absolute',
 top: `0%`,
 left: `0.3%`,
 width: `2%`,
 height: `100%`,
 cursor: 'pointer',
 transform: `rotate(${20}deg)`
},
targetIconStyle:{
  position: 'absolute',
  top: `-60%`,
  left: `-3.6%`
}, territoryWidth:  '2.4%',territoryHeight: '8vh'  }, // African connecting nodes
//#endregion

];

export default GameBoardData;